
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Group } from '@/types/Catalogs'
import { GroupStatus } from '@/types/catalogs/Groups'

@Component({
  name: 'GroupSelector'
})
export default class GroupSelector extends Vue {
  @Prop({ required: true })
  group: Group

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: false })
  opened: boolean

  @Prop({ required: false, default: 0 })
  selectedId: number

  open = false

  get title () {
    return this.open ? 'Ocultar subgrupos' : 'Ver subgrupos'
  }

  get isSelected () {
    return this.selectedId === this.group.id
  }

  get isInactive () {
    return this.group.status === GroupStatus.INACTIVE
  }

  get hasSubgroups () {
    return this.group.subGroups.length > 0
  }

  get titleSelect () {
    return this.isSelected ? 'Clic para deseleccionar' : 'Clic para seleccionar'
  }

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }
}
